<!--================================
=            SWEETALERT            =
=================================-->

<template>
	<div>
		<v-row>
			<base-header>
				<div slot="page-header">SweetAlert</div>
			</base-header>
		</v-row>

		<v-row>
			<v-col class="col-12 col-md-12 col-sm-12">
				<base-card>
					<div slot="card-header">Sweet Alert</div>
					<div slot="card-subheader">Pariatur eu consequat nisi ad commodo sunt dolore est tempor dolor
						eiusmod sit. Esse ea incididunt ad elit minim minim. Incididunt adipisicing nostrud fugiat
						minim ex sint aliqua dolor aliquip elit anim excepteur pariatur.</div>
					<div slot="card-body">
						<v-row class="justify-center mx-auto mt-15 mb-10">
							<v-btn class="ma-2" @click="showAlert()" color="primary">
								Simple Alert
							</v-btn>

							<v-btn color="success" @click="showAlertSuccess()" class="ma-2 white--text">
								Success
								<v-icon right dark>
									mdi-cloud-upload
								</v-icon>
							</v-btn>

							<v-btn class="ma-2" @click="showAlertError" color="error">
								Error

							</v-btn>
							<v-btn class="ma-2" @click="showAlertModal" color="warning">
								Atention

							</v-btn>
							<v-btn class="ma-2" @click="showAlertToast" color="accent">
								Toast

							</v-btn>
						</v-row>

					</div>
				</base-card>
			</v-col>
			<v-col class="col-12 col-md-12 col-sm-12">
				<base-card>
					<div slot="card-header">Sweet Alert More ANimate</div>
					<div slot="card-subheader">Pariatur eu consequat nisi ad commodo sunt dolore est tempor dolor
						eiusmod sit. Esse ea incididunt ad elit minim minim. Incididunt adipisicing nostrud fugiat
						minim ex sint aliqua dolor aliquip elit anim excepteur pariatur.</div>
					<div slot="card-body">
							<v-row class="justify-center mx-auto mt-15 mb-10">
							<v-btn class="ma-2" @click="showAlertImage" color="primary">
								Image Alert
							</v-btn>

							<v-btn color="secondary" @click="showAlertDialog" class="ma-2 white--text">
								Dialog

							</v-btn>

							
					</v-row>

					</div>
				</base-card>
			</v-col>
			<v-col class="col-12 col-md-12 col-sm-12">
				<base-card>
					<div slot="card-header">Sweet Alert</div>
					<div slot="card-subheader">Pariatur eu consequat nisi ad commodo sunt dolore est tempor dolor
						eiusmod sit. Esse ea incididunt ad elit minim minim. Incididunt adipisicing nostrud fugiat
						minim ex sint aliqua dolor aliquip elit anim excepteur pariatur.</div>
					<div slot="card-body">
					<v-row class="justify-center mx-auto mt-15 mb-10"><v-btn class="ma-2" @click="showAlertPosition" color="info">
								Positions
							</v-btn>
							<v-btn class="ma-2" @click="showAlertConfirm" color="warning">
								COnfirm
							</v-btn>
							<v-btn class="ma-2" @click="showAlertSweet" color="accent lighten-3">
								Sweet

							</v-btn></v-row>
					</div> 
				</base-card>
			</v-col>
				
		</v-row>
	</div>

</template>
<script>
	import BaseCard from "../../components/Base/BaseCard.vue";
	import BaseHeader from '../../components/Base/BaseHeader'
	export default {
		components: {
			BaseCard,
			BaseHeader
		},
		mounted() {

		},
		methods: {
			showAlert() {
				this.$swal("Alerta padrão!!!");
			},
			showAlertSuccess() {
				this.$swal("Sucesso", "Senha atualizada com sucesso!", "success");
			},
			showAlertError() {
				this.$swal("Oops...", "Algum erro aconteceu!", "error");
			},
			showAlertModal() {
				this.$swal({
					title: "Some Risk File Is Founded",

				});
			},
			showAlertToast() {
				Toast.fire("Dados cadastrados com sucesso", "", "success");
			},
			showAlertImage() {
				Swal.fire({
					imageUrl: 'https://placeholder.pics/svg/300x1500',
					imageHeight: 400,
					imageWidth: 300,
					imageAlt: 'A tall image'
				})
			},
			showAlertDialog() {
				Swal.fire({
					title: 'Do you want to save the changes?',
					showDenyButton: true,
					showCancelButton: true,
					confirmButtonText: 'Save',
					denyButtonText: `Don't save`,
				}).then((result) => {
					/* Read more about isConfirmed, isDenied below */
					if (result.isConfirmed) {
						Swal.fire('Saved!', '', 'success')
					} else if (result.isDenied) {
						Swal.fire('Changes are not saved', '', 'info')
					}
				})
			},
			showAlertPosition() {
				Swal.fire({
					position: 'top-end',
					icon: 'success',
					title: 'Your work has been saved',
					showConfirmButton: false,
					timer: 1500
				})
			},
			showAlertConfirm() {
				Swal.fire({
					title: 'Are you sure?',
					text: "You won't be able to revert this!",
					icon: 'warning',
					showCancelButton: true,
					confirmButtonColor: '#3085d6',
					cancelButtonColor: '#d33',
					confirmButtonText: 'Yes, delete it!'
				}).then((result) => {
					if (result.isConfirmed) {
						Swal.fire(
							'Deleted!',
							'Your file has been deleted.',
							'success'
						)
					}
				})
			},
			showAlertSweet() {
				Swal.fire({
					title: 'Sweet!',
					text: 'Modal with a custom image.',
					imageUrl: 'https://unsplash.it/400/200',
					imageWidth: 400,
					imageHeight: 200,
					imageAlt: 'Custom image',
				})
			}

		},

	}
</script>

<!--====  End of SWEETALERT  ====-->
